import React, { useCallback, useContext, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { Button, FormGrid, ItemsForm, LabelFieldFormik, NoticeCard } from '../../../../components';

import classes from './CreateCharge.module.scss';
import { Form, Formik } from 'formik';
import { stringSchema } from '../../../../services/schemas';
import { purchasesFields } from '../../../../store/catalogs/forms/purchases';
import { chargesFields } from '../../../../store/catalogs/forms/Charge';
import { formTypes } from '../../../../store/catalogs/forms';
import { useFetch, useGet } from '../../../../services/hooks';
import apiMethods from '../../../../apis';
import { useSelector } from 'react-redux';
import { customs } from '../../../../components/Buttons/Button/Button';
import { useNavigate } from 'react-router-dom';
import { paths } from '../../../../routes';
import Context from '../../../../store/context';

const valuesPurchases = {
  clientName: '',
  clientComplete: { label: '', value: '' },
  id: '',
  issueDate: '',
  dueDate: '',
  items: [
    {
      description: '',

      invoiceQuantity: 0,

      payableAmount: 0,

      isShow: true
    }
  ]
};

const validationSchema = Yup.object().shape({
  clientName: stringSchema('Campo obligatorio'),
  issueDate: stringSchema('Campo obligatorio'),
  dueDate: stringSchema('Campo obligatorio'),
  id: Yup.string(), // Campo opcional - sin validación obligatoria
  items: Yup.array().of(
    Yup.object().shape({
      description: stringSchema('Campo obligatorio'),
      invoiceQuantity: Yup.number().min(1, '').required(''),
      payableAmount: Yup.number().min(1, 'El monto debe ser mayor que 0').required('Se debe digitar un monto')
      //retefuenteAccountId: '',
      //reteicaAccountId: ''
    })
  )
});

const fieldsCharge = [
  { ...chargesFields.clientName },
  { ...chargesFields.id },
  { ...chargesFields.issueDate },
  { ...chargesFields.dueDate }

  /* purchasesFields.lineExtensionAmount,
  purchasesFields.discounts,
  purchasesFields.payableAmountAfterRetentions */
];

const CreateCharge = ({ refetch}) => {
  const navigate = useNavigate();
  const { businessId } = useSelector(state => state.userData);

  const {
    modal: { hideModal, showError },
    toast: { showSuccess }
  } = useContext(Context);

  const {
    isSuccess: getAllProductsSuccess,
    data: getAllProductsData,
    isError: getAllProductsError
  } = useGet(apiMethods.getAllProducts, [businessId], !!businessId);

  const {
    isSuccess: getAllClientsSuccess,
    data: getAllClientsData,
    isError: getAllClientsError
  } = useGet(apiMethods.getAllClients, [businessId, { status: 'SUCCESS' }], !!businessId);

  const {
    isSuccess: createChargeSuccess,
    sendRequest: createCharge,
    isError: createChargeError,
    errorMessage: errorMessageCreate
  } = useFetch(apiMethods.createCharge, [businessId]);

  const [optionsProducts, setOptionsProducts] = useState([]);

  const [fields, setFields] = useState(fieldsCharge);

  const [itemsState, setItemsState] = useState([
    {
      idx: 0,
      fields: [
        { key: `items.${0}.description`, label: 'Nombre del item' },

        {
          key: `items.${0}.invoiceQuantity`,
          label: 'Cantidad',
          type: formTypes.number
        },
        /*   {
          key: `items.${0}.lineExtensionAmount`,
          label: 'Monto total sin retenciones',
          type: formTypes.money
        }, */
        {
          key: `items.${0}.payableAmount`,
          label: 'Monto total',
          type: formTypes.money
        }
      ]
    }
  ]);

  // Cargar clientes independientemente de productos
  useEffect(() => {
    if (getAllClientsSuccess && getAllClientsData) {
      console.log('Clientes cargados:', getAllClientsData.length);
      const clientOptions = getAllClientsData.map(({ individualName, clientId }) => ({
        value: clientId,
        label: individualName
      }));

      // Crear nuevo array para que React detecte el cambio
      setFields(fieldsCurrentState => {
        const newFields = [...fieldsCurrentState];
        newFields[0] = {
          ...fieldsCurrentState[0],
          options: clientOptions
        };
        return newFields;
      });
    } else if (getAllClientsError) {
      console.error('Error al cargar clientes');
    }
  }, [getAllClientsData, getAllClientsSuccess, getAllClientsError]);

  // Cargar productos independientemente de clientes
  useEffect(() => {
    if (getAllProductsSuccess && getAllProductsData) {
      const optionsProductsCurrent = getAllProductsData.map(({ productId, nameProduct }) => ({
        value: productId,
        label: nameProduct
      }));

      setOptionsProducts(optionsProductsCurrent);
      setItemsState(items => {
        const newItems = [...items];
        newItems[0].fields[0] = { ...newItems[0].fields[0], options: optionsProductsCurrent, type: formTypes.selectComplete };
        return newItems;
      });
    }
  }, [getAllProductsData, getAllProductsSuccess]);

  const onAccept = value => {
    const body = {
      businessId, // ✅ Este es el businessId del cobrador (Yonathan)
      ...value,
      clientId: value.clientComplete.value,
      clientBusinessId: value.clientComplete.value, // ✅ CORRECCIÓN: Agregar businessId del cliente (Mateo)
      clientName: value.clientComplete.label,
      items: value.items.map(item => ({
        ...item,
        lineExtensionAmount: item.payableAmount,
        productId: item.productComplete.value,
        nameProduct: item.productComplete.label,
        description: item.productComplete.label,
      }))
    };
    
    createCharge(body);
  };

  const refetchAndHideModal = useCallback(() => {
    refetch()
    hideModal()
  },[hideModal, refetch])
  

  useEffect(() => {
    if (createChargeSuccess) {
      showSuccess('Cuenta de cobro creada', refetchAndHideModal);
    } else if (createChargeError) {
      showError({ title: 'Crear cuenta de cobro', description: errorMessageCreate });
    }
  }, [createChargeError, createChargeSuccess, errorMessageCreate, refetchAndHideModal, showError, showSuccess]);

  const setField = (key, value, setFieldValue) => {
    if (key === 'clientName') {
      setFieldValue('clientName', value.value);
      setFieldValue('clientComplete', value);
      return;
    }
    setFieldValue(key, value);
  };

  const deleteItemsHandler = idx => {
    setItemsState(fields => {
      const newFields = fields
        .filter(item => item.idx !== idx)
        .map((item, index) => {
          return {
            idx: index,
            fields: item.fields.map(field => {
              const keySplit = field.key.split('.');
              return {
                ...field,
                key: `${keySplit[0]}.${index}.${keySplit[2]}`
              };
            })
          };
        });

      return newFields;
    });
  };

  const addItem = newItem => {
    setItemsState(fields => {
      const newFields = fields.concat(newItem);
      return newFields;
    });
  };

  const itemsForAdd = {
    idx: itemsState.length,
    fields: [
      {
        key: `items.${itemsState.length}.description`,
        label: 'Nombre del item',
        type: formTypes.selectComplete,
        options: optionsProducts
      },

      {
        key: `items.${itemsState.length}.invoiceQuantity`,
        label: 'Cantidad',
        type: formTypes.number
      },
      /*  {
        key: `items.${itemsState.length}.lineExtensionAmount`,
        label: 'Monto total sin retenciones',
        type: formTypes.money
      } */
      {
        key: `items.${itemsState.length}.payableAmount`,
        label: 'Monto total',
        type: formTypes.money
      }
    ]
  };

  const goAddClient = () => {
    navigate(paths.addClient);
    hideModal();
  };

  const setValuesItems = (idx, key, value, setFieldValue) => {
    if (key.includes('description')) {
      setFieldValue(key, value.value);
      setFieldValue(`items.${idx}.productComplete`, value);
      return;
    }
    setFieldValue(key, value);
  };

  return (
    <div>
      <span className='bold-20'>Crear cuenta de cobro</span>

      <NoticeCard
        className={classes.notice}
        text='Para crear una cuenta de cobro de un cliente que no existe en Melo, primero debes crearlo desde la vista de Mis clientes.'
      />

      <Formik initialValues={valuesPurchases} validationSchema={validationSchema} onSubmit={onAccept}>
        {({ setFieldValue, values }) => {
          return (
            <Form className={`${classes.form}`}>
              <FormGrid
                onChange={(key, value) => setField(key, value, setFieldValue, values)}
                fields={fields}
                Render={LabelFieldFormik}
              />
              <ItemsForm
                deleteItemsHandler={deleteItemsHandler}
                isNotEditable={false}
                className={classes.items}
                items={itemsState}
                itemsForAdd={itemsForAdd}
                sendItem={addItem}
                values={values}
                isCharge={true}
                setValuesItems={setValuesItems}
              />
              <div className={classes.button}>
                <Button onClick={goAddClient} custom={customs.secondary}>
                  Agregar cliente
                </Button>
                <Button name='createOrEdit' type='submit'>
                  Subir cuenta
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default CreateCharge;
